import { useState, useEffect, useCallback, useMemo } from 'react';
import { Exporter, ExporterFilters } from '../types/exporter';
import { exporterService } from '../../../../api/cansense/exporterApi';

interface UseExportersReturn {
  exporters: Exporter[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useExporters = (filters?: ExporterFilters): UseExportersReturn => {
  const [exporters, setExporters] = useState<Exporter[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const stableFilters = useMemo(() => filters, [
    filters?.customer_id,
    filters?.category_id,
    filters?.status,
    filters?.search,
  ]);

  const fetchExporters = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await exporterService.getExporters(stableFilters);
      setExporters(data);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to fetch exporters';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  }, [stableFilters]);

  useEffect(() => {
    fetchExporters();
  }, [fetchExporters]);

  return { exporters, loading, error, refetch: fetchExporters };
};
